'use strict';

var Dispatcher = require('dispatcher/SchedulerAppDispatcher'),
    Constants = require('constants/AppConstants'),
    ActionType = Constants.ActionTypes,
    ChronologycActionCreators = {

        openDayNotes: function () {
            Dispatcher.dispatch({
                type: ActionType.OPEN_DAY_NOTES
            });
        },

        closeDayNotes: function () {
            Dispatcher.dispatch({
                type: ActionType.CLOSE_DAY_NOTES
            });
        },

        noteAdded: function () {
            Dispatcher.dispatch({
                type: ActionType.NOTE_ADDED
            });
        },

        noteRemoved: function () {
            Dispatcher.dispatch({
                type: ActionType.NOTE_REMOVED
            });
        },

        noteChanged: function () {
            Dispatcher.dispatch({
                type: ActionType.NOTE_CHANGED
            });
        }



    };

module.exports = ChronologycActionCreators;



/** WEBPACK FOOTER **
 ** ./src/actions/ChronologycActionCreators.js
 **/